









































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal/modal-config.model";
import { computed, ref } from "@vue/composition-api";
import moment from "moment";

/**
 * Audit-Log export.
 *
 * UI only: the range is validated here and handed back on submit. Fetching the
 * log and producing the CSV is a separate piece of work, so this deliberately
 * emits rather than calling an API.
 */
export default Vue.extend({
  components: { Modal },
  setup(_, { emit }) {
    const start_date = ref("");
    const end_date = ref("");
    /** a log cannot be exported for the future */
    const today = moment().format("YYYY-MM-DD");

    const range_inverted = computed(
      () =>
        !!start_date.value &&
        !!end_date.value &&
        moment(end_date.value).isBefore(moment(start_date.value), "day")
    );

    const start_error = computed(() => "");
    const end_error = computed(() => (range_inverted.value ? "inverted" : ""));

    /**
     * Shown only once both dates exist. Complaining that a field is empty
     * before the user has reached it is noise, not help.
     */
    const error = computed(() =>
      range_inverted.value ? "End date cannot be earlier than the start date." : ""
    );

    const is_valid = computed(
      () => !!start_date.value && !!end_date.value && !range_inverted.value
    );

    const field_border = (invalid: boolean) =>
      invalid ? "border-level-h" : "border-main-3";
    const start_border = computed(() => field_border(range_inverted.value));
    const end_border = computed(() => field_border(range_inverted.value));

    const download = () => {
      if (!is_valid.value) return;
      emit("submit", { from: start_date.value, to: end_date.value });
    };

    const config = computed(
      () =>
        ({
          title: "Audit-Log",
          desc: "",
          width: "48rem",
          blank: true,
          withTopRightCloseBtn: true,
        } as ModalConfig)
    );

    return {
      config,
      start_date,
      end_date,
      today,
      error,
      start_error,
      end_error,
      start_border,
      end_border,
      is_valid,
      download,
    };
  },
});
